import merge from 'lodash/merge';
import $api from '../api/index';

const getDefaultState = () => ({
  allIds: [],
  byId: {},
  unread: 0
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  getters: {
    find: (state) => (id) => state.byId[id],
    list: (state, getters) => state.allIds.map(id => getters.find(id))
  },

  actions: {
    async getMessages({ commit }, payload) {
      const { data: messages = [] } = await $api.messages.getMessages(payload);

      messages.forEach(message => {
        commit('add', message);
      });
    },

    async getMessageCount({ commit }, payload) {
      const { data } = await $api.messages.getMessageCount(payload);
      commit('setUnreadCount', data.unread);
    },

    async setMessageRead({ commit, state }, payload) {
      const { data: message } = await $api.messages.markMessageRead(payload);

      commit('update', {
        id: message.id,
        read_at: message.read_at
      });

      commit('setUnreadCount', Math.max(state.unread - 1, 0));
    }
  },

  mutations: {
    add(state, message) {
      if (!state.allIds.includes(message.id)) {
        state.byId[message.id] = message;
        state.allIds.push(message.id);
      } else {
        state.byId[message.id] = merge(
          {},
          state.byId[message.id],
          message
        );
      }
    },

    update(state, message) {
      state.byId[message.id] = merge(
        {},
        state.byId[message.id],
        message
      );
    },

    setUnreadCount(state, unreadCount) {
      state.unread = unreadCount;
    }
  }
};
